module.exports = __webpack_public_path__ + "static/img/4.bce46dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/4/4.png
// module id = 25gQ
// module chunks = 0